//src/services/risks.ts
import { api } from "@/lib/apiClient";
import type {
  RiskCatalog,
  RiskCatalogCreateIn,
  RiskCatalogDetail,
  RiskCatalogStatusIn,
  RiskCatalogUpdateIn,
  RiskActionPlanModelLink,
  RiskActionPlanModelLinkIn,
  RiskCategory,
  RiskTheme,
} from "@/types/risks";
import type { ActionPlanModel } from "@/types/actionPlanModels";

export async function listRiskCategories(params?: {
  risk_theme?: RiskTheme | "";
  is_active?: boolean;
}) {
  return api.get<RiskCategory[]>("/risks/categories", {
    params: {
      risk_theme: params?.risk_theme || undefined,
      is_active:
        typeof params?.is_active === "boolean" ? params.is_active : undefined,
    },
  });
}

export async function listRisks(params?: {
  q?: string;
  risk_category_id?: string;
  risk_theme?: RiskTheme | "";
  is_active?: boolean;
}) {
  return api.get<RiskCatalog[]>("/risks", {
    params: {
      q: params?.q || undefined,
      risk_category_id: params?.risk_category_id || undefined,
      risk_theme: params?.risk_theme || undefined,
      is_active:
        typeof params?.is_active === "boolean" ? params.is_active : undefined,
    },
  });
}

export async function getRisk(riskId: string) {
  return api.get<RiskCatalogDetail>(`/risks/${riskId}`);
}

export async function createRisk(payload: RiskCatalogCreateIn) {
  return api.post<RiskCatalog>("/risks", payload);
}

export async function updateRisk(riskId: string, payload: RiskCatalogUpdateIn) {
  return api.put<RiskCatalog>(`/risks/${riskId}`, payload);
}

export async function setRiskStatus(
  riskId: string,
  payload: RiskCatalogStatusIn,
) {
  return api.patch<RiskCatalog>(`/risks/${riskId}/status`, payload);
}

export async function deleteRisk(riskId: string) {
  return api.delete<void>(`/risks/${riskId}`);
}

export async function listRiskActionPlanModels(riskId: string) {
  return api.get<RiskActionPlanModelLink[]>(`/risks/${riskId}/action-plan-models`);
}

export async function linkActionPlanModelToRisk(
  riskId: string,
  payload: RiskActionPlanModelLinkIn,
) {
  return api.post<RiskActionPlanModelLink>(`/risks/${riskId}/action-plan-models`, payload);
}

export async function unlinkActionPlanModelFromRisk(
  riskId: string,
  actionPlanModelId: string,
) {
  return api.delete<void>(
    `/risks/${riskId}/action-plan-models/${actionPlanModelId}`,
  );
}

export async function listAvailableActionPlanModels(params?: {
  q?: string;
  is_active?: boolean;
}) {
  return api.get<ActionPlanModel[]>("/action-plan-models", {
    params: {
      q: params?.q || undefined,
      is_active:
        typeof params?.is_active === "boolean" ? params.is_active : undefined,
    },
  });
}
